import { Container, Loading } from './Spinner.styles'

const Spinner = () => {
  return (
    <Container>
      <Loading />
    </Container>
  )
}

export default Spinner
